var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button is-block",class:[_vm.color, {'is-loading' : _vm.loading}],on:{"click":function($event){_vm.click($event)}}},[(_vm.icon != '')?_c('span',{staticClass:"icon"},[_c('i',{class:['fa', _vm.icon]})]):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a91146c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/util/LoadingButton.vue
// module id = muyx
// module chunks = 0